import { Platform, TextInput, View } from 'react-native';
import { Text } from '@/components/Text';
import theme from '@/config/theme';
import { styles } from './styles';

interface ThirdConfirmAccountDeleteProps {
  onUserInput: (isEnabled: boolean) => void;
}

function ThirdConfirmAccountDelete({
  onUserInput,
}: ThirdConfirmAccountDeleteProps) {
  return (
    <View style={styles.wrapper}>
      <Text style={styles.bodyText}>
        Schreiben Sie
        <Text style={styles.bold}> &quot;löschen&quot; </Text>
        in das Eingabefeld, um die Löschung Ihres Accounts zu bestätigen.
      </Text>
      <View style={styles.inputWrapper}>
        <TextInput
          allowFontScaling={false}
          autoComplete="off"
          style={[
            styles.input,
            Platform.OS === 'ios'
              ? {
                  lineHeight: 0,
                  color: theme.colors.newUI.therapist.textBlue100,
                }
              : { color: theme.colors.newUI.therapist.textBlue100 },
          ]}
          placeholder="löschen"
          placeholderTextColor="gray"
          onChangeText={(text) =>
            onUserInput(text?.toLowerCase() === 'löschen')
          }
        />
      </View>
    </View>
  );
}

export default ThirdConfirmAccountDelete;
